import { configureStore } from '@reduxjs/toolkit';
import smartReducer from './smart/smartSlice';
import osaRiskReducer from './osaRisk/osaRiskSlice';
import timelineReducer from './timeline/timelineSlice';
import uiReducer from './ui/uiSlice';
import patientResourcesReducer from './patientResources/patientResourcesSlice';
import referralOrderReducer from './referralOrder/referralOrderSlice';
import tabsReducer from './tabs/tabsSlice';
import { listenerMiddleware } from './listeners';
const store = configureStore({
    reducer: {
        smart: smartReducer,
        osaRisk: osaRiskReducer,
        timeline: timelineReducer,
        ui: uiReducer,
        patientResources: patientResourcesReducer,
        referralOrder: referralOrderReducer,
        tabs: tabsReducer
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().prepend(listenerMiddleware.middleware)
});
export default store;
